import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,          // for new file (File object)
    fileName: "",
    remarks: "",
    filePath: "",
    isNew: true,         // ✅ identify new file
    fullUrl: "",         // ✅ for existing file preview
});
const UpdateUnitMaster = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const userName = useSelector(getName);
    const [activeFY, setActiveFY] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false,]);
    const [loading, setloader] = useState(false)
    // Master Listings
    const [bedRoomList, setBedRoomList] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [unitTypeList, setUnitTypeList] = useState([]);
    const [unitViewList, setunitViewList] = useState([]);
    const [contactPerson, setContactPerson] = useState([]);
    const [unitCategoryList, setunitCategoryList] = useState([]);
    const [floorList, setFloorList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [deletedFiles, setDeletedFiles] = useState([]);

    // Unit Listings
    const [furnishing, setFurnishing] = useState([]);
    const [featuresList, setFeaturesList] = useState([]);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const [supplierCheck, setSupplierCheck] = useState("");
    const location = useLocation();
    const leaseData = location.state;
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    const validationRules = [
        { key: "property", message: "Please Select Property" },
        { key: "unitNo", message: "Please Enter Unit No" },
        { key: "unitType", message: "Please Enter Unit Type" },
        { key: "unitCategory", message: "Please Enter Unit Category" },
    ];
    const [transectionData, setTransectionData] = useState({
        property: null,
        unitType: null,
        unitCategory: null,
        contactPerson: null,
        unitNo: '',
        roundoff: '',
        notes: '',
        totalvalue: '',
        mobile: '',
    });
    const [unitDetails, setUnitDetails] = useState({
        bedRooms: null,
        unitView: null,
        furnishing: null,
        utilityRoom: '',
        studyRoom: '',
        laundryRoom: '',
        maidRoom: '',
        storeRoom: '',
        plotNO: '',
        bathRoom: '',
        plotSize: '',
        parking: '',
        balcony: '',
        parkingPrice: '',
        totalArea: '',
        sqftRate: '',
        allPrice: '',
        registrationFee: '',
        completionDate: formattedDate,
    });
    const [salesDetails, setSalesDetails] = useState({
        currency: null,
        orignalPrice: '',
        orignalRateSqft: '',
        profit: '',
        profitCalculate: '',
        listingPrice: '',
        listingPriceRate: '',
        priceinothercontry: '',
        mainSalePrice: '',
        marketAnalysis: '',
        to: '',
        commPaid: '',
        commPaidCalculate: '',
        commSeller: '',
        commSellerCalculate: '',
        sellerTransferFee: '',
        sellerTransferFeeCalcu: '',
        buyerTransferFee: '',
        buyerTransferFeeCalcu: '',
        legalFee: '',
        legalFeeCalcu: '',
        miscFee: '',
        miscFeeCalcu: '',
        comment: '',
        sellerPaidDev: '',
        sellerPaidDevCalcu: '',
        amountDueDev: '',
        amountDueDevCalcu: '',
    });
    const [buyerSummery, setBuyerSummery] = useState({
        sellerTransfer: '',
        developerBalance: '',
        developerBalancePerc: '',
        BuyerCommission: '',
        BuyerCommissionPerc: '',
        DlDTransfer: '',
        DlDTransferPerc: '',
        administrationFee: '',
        administrationFeePerc: '',
        otherFee: '',
        otherFeePerc: '',
        allPrice: '',
        allPricePerc: '',
    });
    const [leaseDetails, setLeaseDetails] = useState({
        dueDate: formattedDate,
        rentPerAnum: '',
        rentByMonth: '',
        rentPerDay: '',
        securityDeposit: '',
        securityDepositPerc: '',
        tenantCommission: '',
        tenantCommissionPerc: '',
        landlordCommission: '',
        landlordCommissionPerc: '',
        maintenanceFee: '',
        rentPayable: '',
        IbanNo: '',
        secDepositPayable: '',
        commissionPayable: '',
        bankName: null,
        accountNo: '',
        fixedCharges: '',
        variableCharges: '',
        installment: '',
    });

    useEffect(() => {
        fetchDropdownData()
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'UMProperties,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMFurnishing,UMBedrooms,UMAgents');
            const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
            setFloorList(res?.data?.dropdowns?.UMFloors)
            setPropertyList(res?.data?.dropdowns?.UMProperties)
            setunitCategoryList(res?.data?.dropdowns?.UMUnitCategories)
            setunitViewList(res?.data?.dropdowns?.UMUnitViews)
            setUnitTypeList(res?.data?.dropdowns?.UMUnitTypes)
            setFurnishing(res?.data?.dropdowns?.UMFurnishing)
            setBedRoomList(res?.data?.dropdowns?.UMBedrooms)
            setContactPerson(res?.data?.dropdowns?.UMAgents)
            if (leaseData) {
                const params = new URLSearchParams();
                params.append('Action', 'GetUnitDetailsByRefNo');
                params.append('UnitRefNo', leaseData?.ref_No);
                const unitres = await apiService.getApiParamater('GET_UNIT_COMMON', `?${params.toString()}`);
                let unitData = unitres?.data?.result?.data
                const unitView = res?.data?.dropdowns?.UMUnitViews?.find(dep => dep.text === leaseData?.unit_View)
                const property = res?.data?.dropdowns?.UMProperties?.find(dep => dep.value === leaseData?.property_No)
                const unitType = res?.data?.dropdowns?.UMUnitTypes?.find(dep => dep.text === leaseData?.unit_Type)
                const unitCategory = res?.data?.dropdowns?.UMUnitCategories?.find(dep => dep.text === leaseData?.unit_Category)
                const furnishing = res?.data?.dropdowns?.UMFurnishing?.find(dep => dep.text === unitData?.Facilities)
                const bedrooms = res?.data?.dropdowns?.UMBedrooms?.find(dep => dep.text === leaseData?.bedrooms)
                const floor = res?.data?.dropdowns?.UMFloors?.find(dep => dep.text === leaseData?.floor)
                const contactPersons = res?.data?.dropdowns?.UMAgents?.find(dep => dep.text === unitData?.Broker_Name)
                setTransectionData({
                    property: { label: property?.text, value: property },
                    unitType: { label: unitType?.text, value: unitType },
                    unitCategory: { label: unitCategory?.text, value: unitCategory },
                    contactPerson: { label: contactPersons?.text, value: contactPersons },
                    unitNo: leaseData?.unit_No || '',
                    roundoff: leaseData?.roundOff_Value || '',
                    notes: leaseData?.remarks || '',
                    totalvalue: leaseData?.total_Value || '',
                    mobile: '',
                });
                setUnitDetails({
                    bedRooms: { label: bedrooms?.text, value: bedrooms },
                    unitView: { label: unitView?.text, value: unitView },
                    furnishing: { label: furnishing?.text, value: furnishing },
                    floor: { label: floor?.text, value: floor },
                    utilityRoom: unitData?.Street_No || '',
                    studyRoom: unitData?.FinanceCompany || '',
                    laundryRoom: unitData?.Street_Name || '',
                    maidRoom: unitData?.StoreRooms || '',
                    storeRoom: leaseData?.storeRooms || '',
                    plotNO: leaseData?.plot_No || '',
                    bathRoom: unitData?.Bathrooms || '',
                    plotSize: leaseData?.plot_Size || '',
                    parking: leaseData?.parking || '',
                    balcony: unitData?.Balcony || '',
                    parkingPrice: leaseData?.parking_Price || '',
                    totalArea: leaseData?.total_Area || '',
                    sqftRate: leaseData?.sqft_Rate || '',
                    allPrice: leaseData?.all_In_Price || '',
                    registrationFee: unitData?.Buyer_TransferFee || '',
                    completionDate: unitData?.completion_Date,
                    rent: unitData?.Rent_Per_Annum,
                });
                setSupplierCheck(unitData?.Leased === true ? "Lease" : "Sale")

                const fileparams = new URLSearchParams();
                fileparams.append('refNo', leaseData?.ref_No);
                fileparams.append('fileCategory', "Images");
                const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
                if (imgRes?.data?.result) {
                    const apiFiles = imgRes.data.result.map((item) => ({
                        id: Date.now() + Math.random(),
                        file: null,
                        fileName: item.fileName,
                        remarks: "",
                        filePath: item?.filePath,
                        isNew: false,              // ✅ OLD FILE
                        fullUrl: item.fullUrl,     // ✅ for preview
                    }));
                    setAttachments([...apiFiles, createEmptyRow()]);
                }
            }
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleSave = async () => {
        try {
            setloader(true);
            for (const rule of validationRules) {
                if (!transectionData?.[rule.key]) {
                    setloader(false);
                    toast.warning(rule.message);
                    return;
                }
            }
            const unitFeatures = featuresList?.map((item, index) => {
                return {
                    status: item?.DescType || "0",
                    description: item?.Description || "0",
                    value: item?.Value,
                    cnt: parseFloat(item?.Cnt) || 0,
                    amount: parseFloat(item?.Amount) || 0,
                    isNewInEdit: item?.IsNewInEdit === 0 ? false : true
                }
            });
            const body = {
                unitMasterMain: {
                    unitMaster: {
                        ref_No: leaseData?.ref_No,
                        property_No: transectionData?.property?.value?.value || "0",
                        property_Name: transectionData?.property?.label || "0",
                        unit_No: transectionData?.unitNo || "0",
                        rerA_STR_No: "0",
                        street_No: unitDetails?.utilityRoom || "0",
                        street_Name: unitDetails?.laundryRoom || "0",
                        unit_Type: transectionData?.unitType?.label || "0",
                        unit_Category: transectionData?.unitCategory?.label || "0",
                        unit_Style: "0",
                        unit_Model: "0",
                        unit_Zone: "0",
                        plot_No: unitDetails?.plotNO || "0",
                        plot_Size: unitDetails?.plotSize || "0",
                        block: "0",
                        floor: unitDetails?.floor?.label || "0",
                        unit_View: unitDetails?.unitView?.label || "0",
                        completion_Date: unitDetails?.completionDate,
                        unit_Class: "0",
                        livingRooms: "0",
                        bedrooms: unitDetails?.bedRooms?.label || "0",
                        storeRooms: unitDetails?.maidRoom || "0",
                        parking: unitDetails?.parking || "0",
                        facilities: unitDetails?.furnishing?.label || "0",
                        status: "0",
                        payment_Plan: "0",
                        broker_Name: transectionData?.contactPerson?.label || "0",
                        seller_Id: "0",
                        seller_Name: "0",
                        adv_Listing: true,
                        adv_OpenHouse: true,
                        adv_Remarks1: "0",
                        adv_Remarks2: "0",
                        adv_Remarks3: "0",
                        remarks: transectionData?.notes || "0",
                        internalRemarks: "0",
                        otherSpace1: "0",
                        bathrooms: unitDetails?.bathRoom || "0",
                        balcony: unitDetails?.balcony || "0",
                        terrace: "0",
                        total_Area: parseFloat(unitDetails?.totalArea) || 0,
                        measured_Area: 0,
                        sqft_Rate: parseFloat(unitDetails?.sqftRate || 0),
                        purchase_Value: 0,
                        total_Value: parseFloat(transectionData?.totalvalue || 0),
                        measured_Value: 0,
                        roundOff_Value: parseFloat(transectionData?.roundoff || 0),
                        parking_Price: parseFloat(unitDetails?.parkingPrice) || 0,
                        all_In_Price: parseFloat(unitDetails?.allPrice || 0),
                        premium: 0,
                        premium_Percent: 0,
                        seller_Commission: 0,
                        seller_Commission_Percent: 0,
                        buyer_Commission: 0,
                        buyer_Commission_Percent: 0,
                        seller_TransferFee: 0,
                        seller_TransferFee_Percent: 0,
                        buyer_TransferFee: parseFloat(unitDetails?.registrationFee || 0),
                        buyer_TransferFee_Percent: 0,
                        admin_Fees: 0,
                        admin_Fees_Percent: 0,
                        other_Fees: 0,
                        other_Fees_Percent: 0,
                        other_Fees_Remarks: "0",
                        seller_Paid: 0,
                        seller_Paid_Percent: 0,
                        developer_Due: 0,
                        developer_Due_Percent: 0,
                        rent_Per_Annum: parseFloat(unitDetails?.rent || 0),
                        short_Term_Rent: 0,
                        short_Term_Period: "0",
                        rent_Per_Day: 0,
                        security_Deposit: 0,
                        advance_Deposit: 0,
                        tenant_Commission: 0,
                        landlord_Commission: 0,
                        maintenance_Fee: 0,
                        negotiable: true,
                        currency: "0",
                        cmA_Range1: 0,
                        cmA_Range2: 0,
                        installments: 0,
                        rentPayableTo: "0",
                        rentBankName: "0",
                        rentBankAcNo: "0",
                        secDepPayableTo: "0",
                        comPayableTo: "0",
                        key_Status: "0",
                        publishStatus: true,
                        serviceCharge: "0",
                        ownerOccupied: true,
                        leased: supplierCheck === "Lease" ? true : false,
                        leaseAmount: 0,
                        leaseExpiry: unitDetails?.expiryDate,
                        mandate: "0",
                        financeCompany: unitDetails?.studyRoom || "0",
                        mortgaged: true,
                        mortgageCompany: "0",
                        propertyRegistered: true,
                        portfolio: 0,
                        portfolioManager: "0",
                        propertyType: "0",
                        factor: 0,
                        common: 0,
                        cp: 0,
                        effeciency: "0",
                        listingPriceUSD: 0,
                        monthlyIncome: "0",
                        annualIncome: "0",
                        exp9: "0",
                        exp10: "0",
                        refered_By: "0",
                        refered_On: unitDetails?.reffferedDate,
                        createdBy: userName || "0",
                        createdOn: today,
                        modifiedBy: userName || "0",
                        modifiedOn: today
                    },
                    unitFeatures: unitFeatures,
                    unitImages: [
                        {
                            record_Id: 0,
                            image_Description: "0",
                            image_Filename: "0",
                            isDefault: true,
                            folder: "0",
                            url: "0",
                            isAdded: false,
                            isUpdated: false,
                            isDeleted: false
                        }
                    ],
                    unitPayables: [
                        {
                            description: "0",
                            value: true,
                            landlord: true,
                            tenant: true
                        }
                    ],
                    unitYearlyRents: [
                        {
                            year: 0,
                            rentPerSqftRest: 0,
                            rentPerSqftKitchen: 0,
                            rentPerSqftTerrace: 0,
                            totalRent: 0,
                            scPerSqftRest: 0,
                            scPerSqftKitchen: 0,
                            scPerSqftTerrace: 0,
                            totalServiceCharge: 0,
                            chilledWaterPerSqftRest: 0,
                            chilledWaterPerSqftKitchen: 0,
                            chilledWaterPerSqftTerrace: 0,
                            totalChilledWaterCharge: 0
                        }
                    ],
                    unitFixedCharges: [
                        {
                            description: "0",
                            amount: 0
                        }
                    ]
                }
            }
            const postRes = await apiService.put('UPDATE_UNIT', body);
            if (postRes?.data?.statusCode === 200 || postRes?.data?.statusCode === 201) {
                if (attachments) {
                    handleUpload(postRes?.data?.result?.ref_No)
                }
                toast.success(postRes?.data?.message);
                setloader(false);
                navigate('/Customer/Property/Master/Unit/listing')
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleUpload = async (ref_No) => {
        const formData = new FormData();


        let token = localStorage.getItem('Token');
        let db = localStorage.getItem('DataBase');
        // const validFiles = attachments.filter(
        //     (item) => item.file instanceof File
        // );
        const validFiles = attachments.filter(
            (item) => item.file instanceof File && item.isNew
        );
        validFiles.forEach(({ file }) => {
            formData.append("files", file);
        });

        formData.append("refNo", leaseData?.ref_No);
        formData.append("fileCategory", "Images");

        // ✅ DEBUG
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }

        const response = await axios.post(
            "https://pmkleaseapi.apps.pro360erp.com/api/FileUpload/unit-files",
            formData,
            {
                headers: {
                    accept: "text/plain",
                    apikey: "V+kBloEwqqVho1PINmQI0VJQwSBX2l/e",
                    Authorization: `Bearer ${token}`,
                    db: db,
                },
            }
        );

        console.log(response);
    }
    return (
        <div className='p-3'>
            <div className='border-box2 p-2 d-flex justify-content-between' style={{ borderRadius: "8px" }}>
                <div className=''><h6>Unit Master</h6></div>
                <div className='d-flex gap-3'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>

            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Property Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Unit Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)}>Unit Features
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 7 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(7)}>Images
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<MasterDetails tableLoading={tableLoading}
                setTransectionData={setTransectionData} propertyList={propertyList} setFeaturesList={setFeaturesList}
                transectionData={transectionData} unitTypeList={unitTypeList} contactPerson={contactPerson}
                unitCategoryList={unitCategoryList} setunitCategoryList={setunitCategoryList}

            />)}
            {gridVisibility[1] && (<UnitDetails tableLoading={tableLoading} bedRoomList={bedRoomList} supplierCheck={supplierCheck}
                setTransectionData={setUnitDetails} furnishing={furnishing} setSupplierCheck={setSupplierCheck} floorList={floorList}
                transectionData={unitDetails} unitViewList={unitViewList}
            />)}
            {gridVisibility[2] && (<UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />)}
            {gridVisibility[7] && (<ImagesList attachments={attachments} deletedFiles={deletedFiles} setDeletedFiles={setDeletedFiles} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />)}
        </div>

    );
};
export default UpdateUnitMaster;